import {CounterLabel} from '@primer/styled-react'
import {Count} from '../../react-shared/Count'
import Base from '../components/skeletons/Base'
import styles from './LazyCounter.module.css'

export default function LazyCounter({
  totalResults,
  isLoading,
  resultCountIsLowerBound,
}: {
  totalResults: number
  isLoading: boolean
  resultCountIsLowerBound?: boolean
}) {
  if (isLoading) {
    return <Base className={styles.skeleton} />
  }

  return (
    <CounterLabel data-testid="resolved-count-label" sx={{height: 20, lineHeight: '20px', py: 0, px: 2}}>
      <Count isLowerBound={resultCountIsLowerBound} value={totalResults} />
    </CounterLabel>
  )
}
